export class AccountDetails {
  firstName!: string;
  lastName!: string;
  emailAddress!: string;
  organizationName!: string;
  organizationType!: string;
  phoneNumber?: string;
  countryCode!: string;
  jobTitle!: string;
  password!: string;
  destinationUrl?: string | null;
  recaptchaToken!: string;
  newsletterOptIn: boolean;

  toJson() {
    return {
      firstName: this.firstName,
      lastName: this.lastName,
      emailAddress: this.emailAddress,
      organizationName: this.organizationName,
      organizationType: this.organizationType,
      phoneNumber: this.phoneNumber,
      countryCode: this.countryCode,
      jobTitle: this.jobTitle,
      destinationUrl: this.destinationUrl,
      newsletterOptIn: this.newsletterOptIn,
    };
  }
}
